module.exports = __webpack_public_path__ + "static/media/hf3.png";